export default __webpack_public_path__ + "static/media/numberOne.ecaa253f.svg";